// src/components/Navbar.js
import { FaUser, FaSignOutAlt } from "react-icons/fa"; // Íconos de FontAwesome
import { useTittleContenidoStore } from "../../context/tittleContenidoStore";

interface NavbarProps {
  username: string;
  onLogout: () => void;
}
function Navbar({ username, onLogout }: NavbarProps) {
  const { tittleContenido }: any = useTittleContenidoStore();
  return (
    <nav className="navbar navbar-light fondoVerdeCoopac justify-content-between">
      <span className="navbar-brand mb-0 text-light h1 ms-4">
        {tittleContenido}
      </span>
      <h4 className="text-light me-4">{username}</h4>
    </nav>
  );
}

export default Navbar;
